import React from 'react';
import DashboardRouter from '../components/DashboardRouter';

const Home: React.FC = () => {
  return <DashboardRouter />;
};

export default Home;